"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Replace = exports.Dot = exports.Cdr = exports.Car = exports.ApImplicit = exports.Ap = exports.PatternVar = exports.Var = void 0;
function Var(name) {
    return {
        "@type": "Neutral",
        "@kind": "Var",
        name,
    };
}
exports.Var = Var;
function PatternVar(name) {
    return {
        "@type": "Neutral",
        "@kind": "PatternVar",
        name,
    };
}
exports.PatternVar = PatternVar;
function Ap(target, targetType, arg) {
    return {
        "@type": "Neutral",
        "@kind": "Ap",
        target,
        targetType,
        arg,
    };
}
exports.Ap = Ap;
function ApImplicit(target, targetType, arg) {
    return {
        "@type": "Neutral",
        "@kind": "ApImplicit",
        targetType,
        target,
        arg,
    };
}
exports.ApImplicit = ApImplicit;
function Car(target, targetType) {
    return {
        "@type": "Neutral",
        "@kind": "Car",
        target,
        targetType,
    };
}
exports.Car = Car;
function Cdr(target, targetType) {
    return {
        "@type": "Neutral",
        "@kind": "Cdr",
        target,
        targetType,
    };
}
exports.Cdr = Cdr;
function Dot(target, targetType, name) {
    return {
        "@type": "Neutral",
        "@kind": "Dot",
        target,
        targetType,
        name,
    };
}
exports.Dot = Dot;
function Replace(target, targetType, motive, base) {
    return {
        "@type": "Neutral",
        "@kind": "Replace",
        target,
        targetType,
        motive,
        base,
    };
}
exports.Replace = Replace;
//# sourceMappingURL=Neutral.js.map